import { useMemo } from 'react'
import NetworkListBox from '~/components/TokenListModal/components/NetworkListBox'
import {
  Mainnet,
  Sepolia,
  ArbitrumOne,
  ArbitrumRinkeby,
} from '~/model/chain/ethereum'
import { ENV } from '~/constants/env'

interface NetworkListProps {
  selectedChainId: number | null
  setSelectedChainId: (chainId: number | null) => void
}

const NetworkList: React.FC<NetworkListProps> = ({
  selectedChainId,
  setSelectedChainId,
}) => {
  const networks = useMemo(() => {
    const isDev = ENV.development || ENV.local
    return isDev ? [Sepolia, ArbitrumRinkeby] : [Mainnet, ArbitrumOne]
  }, [])

  const handleSelectNetwork = (chainId: number | null) => {
    setSelectedChainId(chainId)
  }

  return (
    <NetworkListBox
      networks={networks}
      selectedChainId={selectedChainId}
      handleSelectNetwork={handleSelectNetwork}
    />
  )
}

export default NetworkList
